import InfiniteScroll from "react-infinite-scroll-component";
import { t } from "@/i18n-js/instance";
import { PostItem as PostV3Item } from "@/react/components/PostsV3/PostViewList/PostItem";
import { LoaderRow } from "@circle-react/components/shared/LoaderRow";
import { CurrentSpaceContextProvider } from "@circle-react/contexts";
import { PostsDetailsContextProvider } from "@circle-react/contexts/postsDetailsContext";
import { useProfilePostsList } from "@circle-react/hooks/profile/useProfilePostsList";
import EmptyState from "../EmptyState";
import "./styles.scss";

export const ProfilePosts = ({
  memberPublicId,
  shouldOpenInNewTab,
  scrollableTarget = "panel",
}: any) => {
  const { fetchNextPage, posts, data, hasNextPage, isLoading, onPostChange } =
    useProfilePostsList({
      memberPublicId,
    });

  if (isLoading) {
    return <LoaderRow />;
  }

  if (posts.length < 1)
    return (
      <EmptyState
        title={t("profile_drawer.posts.empty_state.title")}
        subtitle={t("profile_drawer.posts.empty_state.subtitle")}
      />
    );

  const perPagePosts: any = data?.pages.map((page: any) =>
    page.records.map((post: any) => post.id),
  );

  const defaultScrollableTarget = "profile-posts-scrollable-target";

  return (
    <PostsDetailsContextProvider perPagePostIds={perPagePosts}>
      <div
        className="profile-posts bg-tertiary h-full overflow-auto"
        id="profile-posts-scrollable-target"
      >
        <InfiniteScroll
          style={{ overflow: "initial" }}
          scrollThreshold={0.5}
          next={fetchNextPage}
          hasMore={!!hasNextPage}
          loader={<LoaderRow />}
          dataLength={posts.length}
          scrollableTarget={scrollableTarget || defaultScrollableTarget}
          className="space-y-2"
        >
          {posts.map(post => (
            <CurrentSpaceContextProvider key={post.id} spaceId={post.space_id}>
              <PostV3Item
                key={post.id}
                forceSimplifiedView
                onPostChange={onPostChange}
                post={post}
                shouldOpenInNewTab={shouldOpenInNewTab}
              />
            </CurrentSpaceContextProvider>
          ))}
        </InfiniteScroll>
      </div>
    </PostsDetailsContextProvider>
  );
};
